import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const location = useLocation();

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            漫画分类
          </h2>
          <p className="text-foreground-500 text-sm mt-2">探索不同类型的精彩韩漫</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 hover:bg-primary-500 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-hover:bg-background-50/20 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-700 group-hover:text-background-50 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}